import { shallowEqual, useSelector } from 'react-redux';
import { useTariffDetails } from './useTariffDetails';
import { isValidField } from 'utils/fieldValidations';

import {
  selectCurrentTariff,
  selectPostcode,
  selectFuelType,
  selectPaymentMethod,
  selectIsLoadingTariffList,
  selectIsLoadingTariffDetails,
  selectTariffList
} from 'state/tariff-information/tariff-information-slice';

import { FUEL_OPTIONS } from 'config/app-config';

export const useTariffInfo = () => {
  const currentTariff = useSelector(selectCurrentTariff, shallowEqual);
  const tariffs = useSelector(selectTariffList, shallowEqual) || [];
  const tariffDetails = useTariffDetails();

  const fuel = useSelector(selectFuelType, shallowEqual);
  const paymentMethod = useSelector(selectPaymentMethod, shallowEqual);
  const postcode = useSelector(selectPostcode, shallowEqual);

  const isLoadingTariffList = useSelector(
    selectIsLoadingTariffList,
    shallowEqual
  );
  const isLoadingTariffDetails = useSelector(
    selectIsLoadingTariffDetails,
    shallowEqual
  );

  const { id: currentTariffId } = currentTariff || {};
  const isValidPostcode = isValidField(postcode, 'postcode');

  const shouldRenderTariffSelection =
    isValidPostcode && !isLoadingTariffList && !!tariffs.length;
  const showTariffDetails = !!tariffDetails && shouldRenderTariffSelection;

  return {
    isGasOnly: fuel === FUEL_OPTIONS.GAS,
    isElectricityOnly: fuel === FUEL_OPTIONS.ELECTRIC,
    isDualFuel: fuel === FUEL_OPTIONS.DUAL,
    fuel,
    currentTariffId,
    currentTariff,
    tariffs,
    tariffDetails,
    showTariffDetails,
    shouldRenderTariffSelection,
    postcode,
    paymentMethod,
    isLoadingTariffList,
    isLoadingTariffDetails
  };
};
